const { addApiHost } = require('../analyticsIntegrations');

function prepareIntegrations(apiHost) {
    const integrations = { All: true };

    if (apiHost) {
        addApiHost(integrations, 'Segment.io', apiHost);
    }

    return integrations;
}

module.exports = { prepareIntegrations };
